export const BOOLEAN_LIST = [
  {value: true, text: 'Sim'},
  {value: false, text: 'Não'},
]

export const ORDERS_STATUS = {
  CREATED: "CREATED",
  ACCEPTED: "ACCEPTED",
  DECLINED: "DECLINED",
  UNDER_REVIEW: "UNDER_REVIEW",
  ENDED: "ENDED",
}

export const ORDERS_STATUS_DETAILS = [
  {
    text: "Solicitação de serviço",
    buttonText: "Aceitar",
    status: ORDERS_STATUS.CREATED,
    icon: "mdi-airplane-takeoff",
    color: "primary",
    disableActionButton: false,
    disableCreateProcessingButton: true,
    disableDownloadButton: false,
    disableAttachButton: true,

  },
  {
    text: "Cancelado",
    buttonText: "Serviço cancelado",
    status: ORDERS_STATUS.DECLINED,
    icon: "mdi-alert",
    color: "warning",
    disableActionButton: true,
    disableCreateProcessingButton: true,
    disableDownloadButton: true,
    disableAttachButton: true,

  },
  {
    text: "Serviço aceito",
    buttonText: "Finalizar serviço",
    status: ORDERS_STATUS.ACCEPTED,
    icon: "mdi-account-check",
    color: "green",
    disableActionButton: false,
    disableCreateProcessingButton: false,
    disableDownloadButton: false,
    disableAttachButton: false,
  },
  {
    text: "Em revisão",
    buttonText: "Serviço finalizado",
    status: ORDERS_STATUS.UNDER_REVIEW,
    icon: "mdi-file-eye",
    color: "primary",
    disableActionButton: true,
    disableCreateProcessingButton: true,
    disableDownloadButton: true,
    disableAttachButton: true,
  },
  {
    text: "Aprovado",
    buttonText: "Serviço finalizado",
    status: ORDERS_STATUS.ENDED,
    icon: "mdi-check-decagram",
    color: "success",
    disableActionButton: true,
    disableCreateProcessingButton: true,
    disableDownloadButton: true,
    disableAttachButton: true,
  }
]
